import { Navigate } from 'react-router-dom';
import { useTechPredAuth } from './TechPredAuthProvider';

const TechPredPrivateRoute = ({ children }) => {
  const { isTechPredAuthenticated } = useTechPredAuth();
  if (!isTechPredAuthenticated) {
    // If not authenticated, redirect to login page
    return <Navigate to="/techpred/login" />;
  }

  // If authenticated, render the children (protected route content)
  return children;
};

export default TechPredPrivateRoute;
